export { default } from './WorkspaceRecordingSection';
